const ZENDESK_SUBMIT_REQUEST_URI =
  'https://linearb.zendesk.com/hc/en-us/requests/new';

export const openSupportRequest = () =>
  window.open(ZENDESK_SUBMIT_REQUEST_URI, '_blank');
// Upgrade Bots
